import { render, staticRenderFns } from "./GColorForm.vue?vue&type=template&id=61ea26e8&"
import script from "./GColorForm.vue?vue&type=script&lang=ts&"
export * from "./GColorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports